import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createContext, useReducer, useMemo } from 'react';
import { SET_CARE_PROVIDER_ROLES, SET_ROLE_GROUPS, SET_PATIENT_TEAM, SET_PATIENT_ASSIGNMENTS, SET_ORDERS_MODE, ADD_EDITING_DATA, CLEAR_EDITING_DATA, REMOVE_EDITING_ROLEGROUP, REMOVE_ORDER_ENTRY, ADD_ORDER_DATE } from './constants';
import { updateVForderData } from './utils';
const initialState = {
  careProviderRolesGlobal: null,
  roleGroupsGlobal: null,
  patientTeamGlobal: null,
  patientAssignmentGlobal: null,
  VFordersMode: false,
  VFOrderDate: null,
  VForderData: {},
  dispatchVF: null
};
const initVFGlobalContext = {
  careProviderRolesGlobal: null,
  roleGroupsGlobal: null,
  patientTeamGlobal: null,
  patientAssignmentGlobal: null,
  VFOrderDate: null,
  VForderData: {},
  dispatchVF: null
};
export const VFGlobalContextReducer = (state, action) => {
  let newState = _objectSpread({}, state);

  switch (action.type) {
    case SET_CARE_PROVIDER_ROLES:
      newState.careProviderRolesGlobal = action.payload;
      break;

    case SET_ROLE_GROUPS:
      newState.roleGroupsGlobal = action.payload;
      break;
    // web/api/teams?agency=demo1&tenId=demo1&siteId=17

    case SET_PATIENT_TEAM:
      newState.patientTeamGlobal = action.payload;
      break;
    // api/patient/assignments/3908/roleassignments?agency=demo1

    case SET_PATIENT_ASSIGNMENTS:
      newState.patientAssignmentGlobal = action.payload;
      break;

    case SET_ORDERS_MODE:
      newState.VFordersMode = action.payload;
      break;

    case ADD_EDITING_DATA:
      newState.VForderData = updateVForderData(newState.VForderData, action.payload);
      break;

    case ADD_ORDER_DATE:
      newState.VFOrderDate = action.payload;
      break;

    case REMOVE_EDITING_ROLEGROUP:
      delete newState.VForderData[action.payload];
      break;

    case REMOVE_ORDER_ENTRY:
      if (action.payload) {
        delete newState.VForderData[action.payload];
      }

      break;

    case CLEAR_EDITING_DATA:
      newState.VForderData = {};
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
export const VFGlobalContext = /*#__PURE__*/createContext(initVFGlobalContext);
export const VFGlobaldispatchContext = /*#__PURE__*/createContext({});
export const VFGlobalContextConsumer = VFGlobalContext.Consumer;
export const VFGlobaldispatchContextConsumer = VFGlobaldispatchContext.Consumer;
export const VFGlobalContextProvider = ({
  children
}) => {
  const [{
    careProviderRolesGlobal,
    roleGroupsGlobal,
    patientTeamGlobal,
    patientAssignmentGlobal,
    VFordersMode,
    VFOrderDate,
    VForderData
  }, dispatch] = useReducer(VFGlobalContextReducer, initialState);

  const resetVFOrderWorkflow = () => {
    dispatch({
      type: ADD_ORDER_DATE,
      payload: null
    });
    dispatch({
      type: CLEAR_EDITING_DATA,
      payload: null
    });
    dispatch({
      type: SET_ORDERS_MODE,
      payload: false
    });
  };

  const context = useMemo(() => ({
    careProviderRolesGlobal,
    roleGroupsGlobal,
    patientTeamGlobal,
    patientAssignmentGlobal,
    VFordersMode,
    VFOrderDate,
    VForderData,
    resetVFOrderWorkflow,
    dispatchVF: dispatch
  }), [careProviderRolesGlobal, roleGroupsGlobal, patientTeamGlobal, patientAssignmentGlobal, VFordersMode, VFOrderDate, VForderData, dispatch]);
  return /*#__PURE__*/React.createElement(VFGlobalContext.Provider, {
    value: context
  }, children);
};
export function withVFGlobalContext(Component) {
  return function contextComponent(props) {
    return /*#__PURE__*/React.createElement(VFGlobalContextConsumer, null, context => /*#__PURE__*/React.createElement(VFGlobaldispatchContextConsumer, null, dispatchContext => /*#__PURE__*/React.createElement(Component, _extends({}, props, context, dispatchContext))));
  };
}
export default VFGlobalContext;